/*
 * Copyright (c) Dito Technologies
 */

import React from "react";

export default function UseSheetMusicFile(file: File) {
    const [result, setResult] = React.useState<string | null>(null);

    React.useEffect(() => {
        let reader = new FileReader();
        reader.onload = (e) => {
            const target = e.target?.result;
            if (target) {
                setResult(target as string);
            }
        };
        reader.readAsDataURL(file)
    }, [file])

    return result;

}